export class AlphaNumericSortHelper
{
    public static alphaNumericSort(a, b, property: string): number
    {
        const reA = /[^a-zA-Z]/g;
        const reN = /[^0-9]/g;
        const aValue = a && (property in a)? a[property]: "";
        const bValue = b && (property in b)? b[property]: "";
        const aA = aValue.replace(reA, "");
        const bA = bValue.replace(reA, "");
        if (aA === bA) {
            const aN = parseInt(aValue.replace(reN, ""), 10);
            const bN = parseInt(bValue.replace(reN, ""), 10);
            return aN === bN ? 0 : aN > bN ? 1 : -1;
        } else {
            return aA > bA ? 1 : -1;
        }
    }
}